import request from '../utils/request';
import axios from 'axios'

export const ChatUserAPI = {
    /**
     * 获取图片验证码
     * @param {string} phone 手机号
     * @param {number} type 验证码类型，0 注册，1 修改密码
     */
    queryImageCode(phone, type) {
        return request({
            method: "get",
            url: "/api/users/image-code",
            params: {
                "phone": phone,
                "type": type
            }
        })
    },

    /**
     * 发送手机验证码
     * @param {string} phone 手机号
     * @param {number} type 验证码类型，0 注册，1 修改密码
     * @param {string} imageCode 图形验证码
     */
    sendSmsCode(phone, type, imageCode) {
        return request({
            method: "post",
            url: "/api/users/send-sms-code",
            data: {
                "image_code": imageCode,
                "phone": phone,
                "type": type
            }
        })
    },

    /**
     * 注册
     * @param {object} form phone, password, name, sms_code
     */
    register(form) {
        console.info(form)
        return request({
            method: "post",
            url: "/api/users/register",
            data: {
                "name": form.nickname,
                "sms_code": form.verify,
                "phone": form.phone,
                "password": form.password
            }
        })
    },

    /**
     * 修改密码
     * @param {object} form phone, password, sms_code
     */
    editPassword(form) {
        return request({
            method: "put",
            url: "/api/users/edit-password",
            data: {
                "sms_code": form.verify,
                "phone": form.phone,
                "password": form.password
            }
        })
    },

    /**
     * 登录
     * @param {object} data phone, password
     */
    login(data) {
        return request({
            method: "post",
            url: "/api/users/login",
            data
        })
    },

    /**
     * 登出
     */
    logout(data) {
        return request({
            method: "post",
            url: "/api/users/logout",
            data
        })
    },

    /**
     * 获取用户信息
     */
    info() {
        return request({
            method: "get",
            url: "/api/users/info",
            async: false
        })
    },

    /**
     * 同步请求用户信息
     * @param {*} token 
     * @returns 
     */
    async asyncInfo(token) {
        const baseURL = process.env.BASE_API;
        return await axios({
            method: "get",
            url: baseURL + "/api/users/info",
            headers: {
                "t-token": token
            },
            async: false
        })
    }
};


// WEBPACK FOOTER //
// ./src/api/user.js